import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { ControlFieldComponent } from '../control-field/control-field.component';
import { PrimeNgControlComponent } from '../prime-ng-control/prime-ng-control.component';
import { DropdownOption } from './dropdown.model';

@Component({
  selector: 'ui-dropdown',
  standalone: true,
  imports: [DropdownModule, ControlFieldComponent, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownComponent),
      multi: true,
    },
  ],
  templateUrl: './dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownComponent<T> extends PrimeNgControlComponent<T | null> {
  public readonly options = input<DropdownOption<T>[]>();
}
